angular.module('routes.simulation.widgets.SimulationWidgetsPayloadResolver', [
  'stack'
])

/**
 * The SimulationWidgetsPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class SimulationWidgetsPayloadResolver
 * @constructor
 * @module routes.simulation.widgets.SimulationWidgetsPayloadResolver
 */
.factory('SimulationWidgetsPayloadResolver', [
  'GLOBAL',
  'ModelsService',
  function (GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      if (params.widgetId && params.widgetId !== 'events' && params.widgetId !== 'sbar') {
        return ModelsService.get('widgets', GLOBAL.apiPath + '/widgets', { id: params.widgetId });
      }
      return {};
    };
  }
]);
